module.exports = vendors_tr_e0004aac727d0f392b52;